import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-l",
  "use": "icon-arrow-l-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-arrow-l\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.966 12.243 2.196 8.47a.667.667 0 0 1 0-.942l3.77-3.772a.667.667 0 0 1 .943.943L4.276 7.333h8.828a.667.667 0 1 1 0 1.334H4.276L6.91 11.3a.667.667 0 0 1-.943.943Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol